import api from "./Api";

class IntegracaoShopeeService {
  GetConfiguracao() {
    return api
      .get("/v1/configuracoes/shopee")
      .then((response) => response.data);
  }

  Ativar(payload) {
    return api
      .post("/v1/configuracoes/shopee/ativar", payload)
      .then((response) => response.data);
  }

  Autorizar(returnUrl) {
    return api
      .get("/v1/configuracoes/shopee/autorizar", {
        params: {
          returnUrl,
        },
      })
      .then((response) => response.data);
  }

  Desconectar() {
    return api
      .post("/v1/configuracoes/shopee/desconectar")
      .then((response) => response.data);
  }
}

export default new IntegracaoShopeeService();
